module.exports = __webpack_public_path__ + "static/media/asset1.4b8cff87.png";